import type { HTMLAttributes } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  title?: string;
}

export function Card({ title, children, className = '', ...props }: CardProps) {
  return (
    <div
      className={`bg-brand-surface/80 rounded-2xl border border-white/[0.08] p-5 shadow-[inset_0_1px_0_rgba(255,255,255,0.04)] ${className}`}
      {...props}
    >
      {title && (
        <h3 className="text-xs font-semibold text-white/45 uppercase tracking-[0.08em] mb-3">{title}</h3>
      )}
      {children}
    </div>
  );
}
